import { render, staticRenderFns } from "./parkList.vue?vue&type=template&id=2e9bc193&scoped=true&"
import script from "./parkList.vue?vue&type=script&lang=js&"
export * from "./parkList.vue?vue&type=script&lang=js&"
import style0 from "./parkList.vue?vue&type=style&index=0&id=2e9bc193&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9bc193",
  null
  
)

component.options.__file = "parkList.vue"
export default component.exports